<template>
  <svg
    width="52"
    height="53"
    viewBox="0 0 52 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="52"
      height="52"
      rx="26"
      fill="#E5E5E5"
      fill-opacity="0.3"
    />
    <g clip-path="url(#clip0_1493_326020)">
      <path
        d="M27.125 25V25.375H27.5H34.5C34.7984 25.375 35.0845 25.4935 35.2955 25.7045C35.5065 25.9155 35.625 26.2016 35.625 26.5C35.625 26.7984 35.5065 27.0845 35.2955 27.2955C35.0845 27.5065 34.7984 27.625 34.5 27.625H27.5H27.125V28V35C27.125 35.2984 27.0065 35.5845 26.7955 35.7955C26.5845 36.0065 26.2984 36.125 26 36.125C25.7016 36.125 25.4155 36.0065 25.2045 35.7955C24.9935 35.5845 24.875 35.2984 24.875 35V28V27.625H24.5H17.5C17.2016 27.625 16.9155 27.5065 16.7045 27.2955C16.4935 27.0845 16.375 26.7984 16.375 26.5C16.375 26.2016 16.4935 25.9155 16.7045 25.7045C16.9155 25.4935 17.2016 25.375 17.5 25.375H24.5H24.875V25V18C24.875 17.7016 24.9935 17.4155 25.2045 17.2045C25.4155 16.9935 25.7016 16.875 26 16.875C26.2984 16.875 26.5845 16.9935 26.7955 17.2045C27.0065 17.4155 27.125 17.7016 27.125 18V25ZM26 6.875C36.8389 6.875 45.625 15.6611 45.625 26.5C45.625 37.3389 36.8389 46.125 26 46.125C15.1611 46.125 6.375 37.3389 6.375 26.5C6.375 15.6611 15.1611 6.875 26 6.875ZM26 9.125C21.3919 9.125 16.9725 10.9556 13.714 14.214C10.4556 17.4725 8.625 21.8919 8.625 26.5C8.625 31.1081 10.4556 35.5275 13.714 38.786C16.9725 42.0444 21.3919 43.875 26 43.875C30.6081 43.875 35.0275 42.0444 38.286 38.786C41.5444 35.5275 43.375 31.1081 43.375 26.5C43.375 21.8919 41.5444 17.4725 38.286 14.214C35.0275 10.9556 30.6081 9.125 26 9.125Z"
        fill="white"
        stroke="#4F6184"
        stroke-width="0.75"
      />
    </g>
    <defs>
      <clipPath id="clip0_1493_326020">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(6 6.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
